
export default {
  free: 'free',
  silver: 'silver',
  gold: 'gold',
};



// WEBPACK FOOTER //
// ./src/models/SubscriptionPlans.js